var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureAsset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12.002v48h60v-48H6zm7.5 21h-3v-9h3v9zM13.5 48h-3v-9h3v9zM51 24.007H37.5v8.25H51v-8.25z",
    fill: "url(#paint0_linear_1288_32000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18h48v36H12v-5.998h1.5v-9H12v-6h1.5v-9H12V18zm39 6.007H37.5v8.25H51v-8.25z",
    fill: "url(#paint1_linear_1288_32000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33 2.625l2.625 2.625 2.625-2.625L35.625 0 33 2.625zM0 31.502l1.5 1.5 1.5-1.5-1.5-1.5-1.5 1.5zM49.5 69h3v-3h-3v3zm-39-35.997h3v-9h-3v9zM10.5 48h3v-9h-3v9z",
    fill: "#76808F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48.006h-3v-24h3v24z",
    fill: "url(#paint2_linear_1288_32000)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 34.506h3v3h-3v-3z",
    fill: "url(#paint3_linear_1288_32000)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 34.506h-3v3h3v-3z",
    fill: "url(#paint4_linear_1288_32000)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 34.506h3v3h-3v-3z",
    fill: "url(#paint5_linear_1288_32000)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 39.759h-3v3h3v-3z",
    fill: "url(#paint6_linear_1288_32000)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48 39.759h3v3h-3v-3z",
    fill: "url(#paint7_linear_1288_32000)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 39.759h-3v3h3v-3z",
    fill: "url(#paint8_linear_1288_32000)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 45.007h3v3h-3v-3z",
    fill: "url(#paint9_linear_1288_32000)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45.007h-3v3h3v-3z",
    fill: "url(#paint10_linear_1288_32000)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 45.007h3v3h-3v-3z",
    fill: "url(#paint11_linear_1288_32000)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_32000",
    x1: 6,
    y1: 12.003,
    x2: 66,
    y2: 12.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_32000",
    x1: 36,
    y1: 54,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1288_32000",
    x1: 46.688,
    y1: 24.004,
    x2: 46.688,
    y2: 48.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureAsset);
export default __webpack_public_path__ + "static/media/secure-asset.8fd3c41d5009ea0e612f48a83812d2dd.svg";
export { ForwardRef as ReactComponent };